import { getData } from 'conversations-async-data/async-data/operators/getters';
import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { useChannelInstances } from 'conversations-thread-data/channel-instances/public/hooks';
import { useMigrationStateForInbox } from 'svh-onboarding-config-shared-lib/migration/hooks/useMigrationState';
import { getInboxActiveMigrationInfo } from '../../operators/getInboxActiveMigrationInfo';
import EmailMigrationBanner from './EmailMigrationBanner';
import FormMigrationBanner from './FormMigrationBanner';
import ChatflowMigrationBanner from './ChatflowMigrationBanner';
import CallingMigrationBanner from './CallingMigrationBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const invalidMigrationChannelType = channelType => channelType !== ChannelTypes.EMAIL && channelType !== ChannelTypes.FORMS && channelType !== ChannelTypes.CALLING && channelType !== ChannelTypes.CHAT;
const InboxMigrationBanner = ({
  inboxId
}) => {
  const {
    asyncChannelInstances
  } = useChannelInstances({
    inboxId
  });
  const channelInstancesData = getData(asyncChannelInstances);
  const channels = channelInstancesData ? channelInstancesData.toJS() : [];
  if (!inboxId) {
    return null;
  }

  // useMigrationStateForInbox makes a call to get the migration state for the inbox
  // and returns an empty array if there's no channel migration in progress
  // or an array of migration states if there is a migration in progress
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const inboxMigrationState = useMigrationStateForInbox(inboxId);
  // getInboxActiveMigrationInfo returns the channel info for the active migration
  // or null if there's no active migration
  const inboxActiveMigrationInfo = getInboxActiveMigrationInfo(channels, inboxMigrationState);
  if (!inboxActiveMigrationInfo || invalidMigrationChannelType(inboxActiveMigrationInfo.type)) {
    return null;
  }

  // render the appropriate migration banner based on the channel type
  // we currently support email, forms, and chatflow (live chat only) migration
  if (inboxActiveMigrationInfo.type === ChannelTypes.EMAIL) {
    return /*#__PURE__*/_jsx(EmailMigrationBanner, {
      channel: inboxActiveMigrationInfo,
      inboxId: inboxId
    });
  }
  if (inboxActiveMigrationInfo.type === ChannelTypes.FORMS) {
    return /*#__PURE__*/_jsx(FormMigrationBanner, {
      channel: inboxActiveMigrationInfo,
      inboxId: inboxId
    });
  }
  if (inboxActiveMigrationInfo.type === ChannelTypes.CALLING) {
    return /*#__PURE__*/_jsx(CallingMigrationBanner, {
      channel: inboxActiveMigrationInfo,
      inboxId: inboxId
    });
  }
  return /*#__PURE__*/_jsx(ChatflowMigrationBanner, {
    channel: inboxActiveMigrationInfo
  });
};
InboxMigrationBanner.displayName = 'InboxMigrationBanner';
export default InboxMigrationBanner;